import { Route, Routes } from "react-router-dom";
import { RouteWithNotFound } from "../helpers/RouteWithNotFound";

interface Props {
    children: JSX.Element[] | JSX.Element;
}

function RoutesWithNotFound({children}: Props) {
    return (
        <Routes>
            {children}
            <Route path="*" element={<RouteWithNotFound/>}/>
        </Routes>
    )
}

export default RoutesWithNotFound;
